<!-- src/components/EquipmentImages.vue -->
<template>
  <div class="equipment-images-page">
    <table>
      <thead>
        <tr>
          <th>儀器類別</th>
          <th>儀器代號</th>
          <th>儀器中文名稱</th>
          <th>儀器英文名稱</th>
          <th>單位說明</th>
          <th>符號規則</th>
        </tr>
      </thead>
      <tbody>
        <!-- 第一級儀器 (SB 類) -->
        <tr>
          <td rowspan="11">第一級儀器 (SB 類)</td>
          <td>BM</td>
          <td>永久水準點</td>
          <td>Deep Bench Mark</td>
          <td rowspan="11">沈陷量 (mm)</td>
          <td rowspan="11">沈陷為負 (−)、隆起為正 (+)</td>
        </tr>
        <tr>
          <td>SB</td>
          <td>結構物或基礎沈陷點</td>
          <td>Settlement Points on Building or Foundation</td>
        </tr>
        <tr>
          <td>SG</td>
          <td>地面型沈陷點</td>
          <td>Surface Settlement Point for ground surfaces</td>
        </tr>
        <tr>
          <td>SM</td>
          <td>混凝土、瀝青舖面型沉陷點</td>
          <td>Settlement Reference Points for Concrete、Asphaltic Pavement</td>
        </tr>
        <tr>
          <td>SU</td>
          <td>公共管線沈陷點</td>
          <td>Settlement Points for Utility</td>
        </tr>
        <tr>
          <td>BRT</td>
          <td>隧道沈陷岩釘</td>
          <td>Bolts for Reference Point in Lining</td>
        </tr>
        <tr>
          <td>SSI</td>
          <td>淺式沈陷計</td>
          <td>Shallow Surface Settlement Indicator</td>
        </tr>
        <tr>
          <td>SP</td>
          <td>沈陷板</td>
          <td>Settlement Plate</td>
        </tr>
        <tr>
          <td>HI</td>
          <td>隆起桿</td>
          <td>Heave Indicator</td>
        </tr>
        <tr>
          <td>EXM</td>
          <td>多點伸縮儀</td>
          <td>Multiple Position Borehole Extensometer</td>
        </tr>
        <tr>
          <td>EXS</td>
          <td>單點伸縮儀</td>
          <td>Single Position Borehole Extensometer</td>
        </tr>
        <!-- 第二級儀器 (SID 類) -->
        <tr>
          <td rowspan="3">第二級儀器 (SID 類)</td>
          <td>SID</td>
          <td>連續壁內傾度管</td>
          <td>Inclinometer Casing in Diaphragm Wall</td>
          <td rowspan="3">側向位移量 (mm)</td>
          <td rowspan="3">向開挖面位移為正 (+)</td>
        </tr>
        <tr>
          <td>SIS</td>
          <td>土壤中傾度管</td>
          <td>Inclinometer Casing in Soil</td>
        </tr>
        <tr>
          <td>ISS</td>
          <td>傾度兼測沈系統</td>
          <td>Inclinometer Casing in Soil with Settlement Measurement</td>
        </tr>
        <!-- 第三級儀器 -->
        <tr>
          <td rowspan="17">第三級儀器</td>
          <td>OW</td>
          <td>水位觀測井</td>
          <td>Observation Well</td>
          <td>水位高程(m)</td>
          <td>依絕對高程之數值而定</td>
        </tr>
        <tr>
          <td>ELP</td>
          <td>電子式水壓計</td>
          <td>Electronic Type Piezometer</td>
          <td rowspan="6">水壓力 (t/m2)</td>
          <td rowspan="6">水壓力(t/m2) <br> 壓力為正(＋)</td>
        </tr>
        <tr>
          <td>PS</td>
          <td>豎管式水壓計</td>
          <td>Casagrande Type Piezometer</td>
        </tr>
        <tr>
          <td>EP</td>
          <td>土/水壓計</td>
          <td>Combined Earth Pressure Cell and Piezometer</td>
        </tr>
        <tr>
          <td>PP</td>
          <td>氣壓式水壓計</td>
          <td>Pneumatic Type Piezometer</td>
        </tr>
        <tr>
          <td>PZ</td>
          <td>襯砌水壓計</td>
          <td>Piezometer in Lining</td>
        </tr>
        <tr>
          <td>EPL</td>
          <td>壁內土壓計</td>
          <td>Earth Presure Cell</td>
        </tr>
        <tr>
          <td>RS</td>
          <td>鋼筋應力計</td>
          <td>Rebar Stress Transducer</td>
          <td rowspan="3">組件應力(kg/cm2)</td>
          <td rowspan="3">拉應力為負(－) <br> 壓應力為正(＋)</td>
        </tr>
        <tr>
          <td>CS</td>
          <td>混凝土應變儀</td>
          <td>Concrete Strainmeter</td>
        </tr>
        <tr>
          <td>PC</td>
          <td>襯砌應力計</td>
          <td>Tunnel Lining Pressure Cell</td>
        </tr>
        <tr>
          <td>LC</td>
          <td>支撐荷重計</td>
          <td>Load Cell for Strutr</td>
          <td rowspan="2">荷重(t)</td>
          <td rowspan="2">壓力為正(＋)</td>
        </tr>
        <tr>
          <td>VG</td>
          <td>支撐用應變計</td>
          <td>Strain Gauge for Strut</td>
        </tr>
        <tr>
          <td>CB</td>
          <td>建物收斂觀測點</td>
          <td>Convergence points on Building</td>
          <td rowspan="2">變位量(mm)</td>
          <td rowspan="2">縮短為負(－) <br> 伸長為正(＋)</td>
        </tr>
        <tr>
          <td>CP</td>
          <td>襯砌收斂觀測點</td>
          <td>Convergence Points in Lining</td>
        </tr>
        <tr>
          <td>CG</td>
          <td>裂縫計</td>
          <td>Crack Gauge</td>
          <td rowspan="2">混凝土變形(mm)</td>
          <td rowspan="2">開裂為正(＋)</td>
        </tr>
        <tr>
          <td>CM</td>
          <td>裂縫儀</td>
          <td>Crack Meter</td>
        </tr>
        <tr>
          <td>TI</td>
          <td>房屋傾斜計</td>
          <td>Tiltmeter</td>
          <td>房屋傾斜量(秒)</td>
          <td>
            法線方向：與開挖面正交之方向向開挖面傾斜為(＋) 
            <br> 
            切線方向：由法線(＋)順時鐘旋轉90°之方向
            <br> 
            向其傾斜為正(＋)
            <img :src="img1" class="img-info"/>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import img1 from '@/assets/kmrt/TI.png';

export default {
  name: 'EquipmentImages',
  data() {
    return {
      img1,
    };
  },
};
</script>

<style scoped>
.equipment-images-page {
  padding: 24px;
  font-family: Arial, sans-serif;
}
table { border-collapse: collapse; width: 100%; }
th, td { border: 1px solid #000; padding: 8px; text-align: center; }
th { background-color: #f2f2f2; border: 1px solid #000; padding: 8px; text-align: center }
.img-info {
  display: flex;
  flex-direction: column;
}

</style>
